import i18n from '@i18n';
import moment from 'moment';
import { formatMoney } from '@/common/client';
import { Cancelled, Lost } from './constants/ticketStatus';

export const scoreSeparator = function scoreSeparator(bet) {
    if (bet.getIn(['opponents', 1])) {
        return parseScoreAsString(bet) || i18n('homeAway.vs.separator');
    }
    return '';
};

function parseScoreAsString(bet) {
    const score = parseScore(bet);
    if (score && score.home) {
        return score.home + (score.away ? ':' + score.away : '');
    }
    return null;
}

export function parseScore(bet) {
    if (bet.get('scoreOpponents')) {
        return { home: bet.get('scoreOpponents').get('home'), away: bet.get('scoreOpponents').get('away') };
    } else if (bet.get('score') && bet.get('score').length) {
        const arr = bet.get('score').split(':');
        return { home: arr[0], away: arr.length > 1 ? arr[1] : undefined };
    }
    return null;
}

export const dateTime = function getUTCTime(time, format) {
    let m = moment(time);
    return m.format(format);
};

export function getTicketWinValue(ticket, currency) {
    switch (ticket.status) {
        case Lost:
            return formatMoney(0, currency, 0);
        case Cancelled:
            return formatMoney(ticket.stake, currency);
        // v light tiketoch a overview nechodi paidOut .. lebo naco ...
        // case ticketStatus.PaidOut:
        //     return formatMoney(ticket.get('paidOut'), currency);
        default:
            return formatMoney(ticket.win, currency);
    }
}

export function getTicketIconClass(ticket) {
    const icon = ticket.displayStatus;
    if (isTicketSaved(ticket)) {
        return 'ticket-state-saved';
    }
    return `ticket-state ticket-state-${icon}`;
}

export const isTicketSaved = ticket => {
    return ticket.source === 'Saved' || ticket.hash.startsWith('saved');
};

export function getBetIconClass(bet) {
    let icon = bet.get('status');
    if (bet.get('source') === 'Saved') {
        icon = 'saved';
    }
    return `ticket-state ticket-state-${icon}`;
}

const today = moment();

export const todayMonthOthers = function(overviewTickets) {
    let lastToday = 0,
        lastInMonth = 0;

    overviewTickets.forEach((ticket, index) => {
        let itemTime = moment(ticket.get('submitDate'));
        if (today.isSame(itemTime, 'day')) {
            lastToday = index + 1;
        }
        if (today.isSame(itemTime, 'month')) {
            lastInMonth = index + 1;
        } else {
            return false;
        }
        return true;
    });
    return [
        overviewTickets.slice(0, lastToday),
        overviewTickets.slice(lastToday, lastInMonth),
        overviewTickets.skip(lastInMonth)
    ];
};
